import { useSubconfigurationNavigationApi } from "../../CustomSubconfigurationNavigation/SubconfigurationNavigationApi";
import { __awaiter, __rest } from "tslib";

import { useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

import {
  useCsCfgObject,
  useCsConfigurationApi,
} from "@plansoft-configuration-renderer/framework";

import { ButtonUi } from "./ButtonUi";

const DEFAULT_COMPONENT_MAPPING = {
  ButtonUi,
};
// eslint-disable-next-line
export function CustomUserDefinedFunctionButton(props: any) {
  const [disabled, setDisabled] = useState(false);
  const {
      functionName,
      input,
      components: Components = DEFAULT_COMPONENT_MAPPING,
    } = props,
    otherProps = __rest(props, ["functionName", "input", "components"]);
  const { invokeUserDefinedFunction } = useCsConfigurationApi();
  const { path } = useCsCfgObject();
  const customPath = props.custom.path;

  const { next, nextDisabled } = useSubconfigurationNavigationApi();
  // eslint-disable-next-line
  function handleClick(): any {
    if (props?.custom?.buttonNextTab === true) {
      next();
      return;
    }
    // @ts-expect-error: This is default behaviour from @plansoft-configuration-renderer
    return __awaiter(this, void 0, void 0, function* () {
      let output;
      try {
        setDisabled(true);

        // @ts-expect-error: This is default behaviour from @plansoft-configuration-renderer
        output = yield invokeUserDefinedFunction({
          name: functionName,
          input,
          path: customPath ? customPath : path,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setDisabled(false);
        if (props?.custom?.nextOnSuccess && output === "True") {
          next();
        }
      }
    });
  }
  return _jsx(
    Components.ButtonUi,
    Object.assign({}, otherProps, {
      onClick: handleClick,
      disabled:
        disabled || (props?.custom?.buttonNextTab === true && nextDisabled),
    }),
  );
}
